<template>
  <div class="QuizAdditional">
    <transition name="fade" appear mode="out-in">
      <QuizText v-if="splashscreen" @nextQuestion="closeSplash" :data="splashscreen" :template="'annexe'" :key="'splash-annexe'"/>
      <QuizAdditional :question="questions[currentIndex]" @nextQuestion="nextQuestion" v-else-if="questions[currentIndex] && questions[currentIndex].type == 'annexe'" :key="questions[currentIndex].id" />
      <QuizBase :question="questions[currentIndex]" @nextQuestion="nextQuestion" v-else-if="questions[currentIndex]" :key="questions[currentIndex].id" :annexe="{ length: questions.length, index: currentIndex + 1 }" />
    </transition>
  </div>
</template>

<script>
  import page from '@/mixins/page'
  import { mapActions, mapState } from 'vuex' 

  import QuizText from "@/components/sections/QuizText"
  import QuizAdditional from "@/components/sections/QuizAdditional"
  import QuizBase from "@/components/sections/QuizBase"

  export default {
    name: "QuizAdditional",
    mixins: [ 'page' ],
    props: [ 'question' ],
    components: { QuizText, QuizBase, QuizAdditional },
    computed: {
      ...mapState([
        'quiz',
        'userResponses'
      ])
    },
    data() {
      return {
        currentIndex: 0,
        questions: [],
        splashscreen: null
      }
    },
    watch: {
      currentIndex()
      {
        console.log(this.currentIndex, '/', this.questions.length)
        if(this.currentIndex >= this.questions.length)
        {
          this.$emit('nextQuestion')
        }
      }
    },
    methods: {
      ...mapActions([
        'setQualiscore'
      ]),
      closeSplash()
      {
        this.splashscreen = null
      },
      nextQuestion()
      {
        this.currentIndex = this.currentIndex + 1
        // this.setQuizIndex(this.currentIndex)
      }
    },
    created()
    {
      if(this.question.condition)
      {
        let question = this.userResponses.find(r => r.question == this.question.condition.question)
        console.log('questionCondition', question, this.question.condition.answers)
        if(!this.question.condition.answers.find(r => r == question.answer))
        {
          this.$emit('nextQuestion')
        }else
        {
          this.splashscreen = this.question.splashscreen

          this.question.subquestions.forEach(sub => {
            this.quiz.qualiscore.questions.forEach(question => {
              if(question.ref == sub)
                this.questions.push(question)
            });
          })
        }
      }else{
        this.question.subquestions.forEach(sub => {
          this.quiz.qualiscore.questions.forEach(question => {
            if(question.ref == sub)
              this.questions.push(question)
          });
        })
      }
    },
    beforeDestroy()
    {
      document.body.querySelector('.Header').classList.remove('Header_withTitle')
      document.body.querySelector('.QuizBackground').classList.remove('QuizBackground_annexe')
    },
    mounted()
    {
      document.body.querySelector('.Header').classList.add('Header_withTitle')
      document.body.querySelector('.QuizBackground').classList.add('QuizBackground_annexe')
    }
  }
</script>

<style lang="stylus">
  .QuizAdditional

    .QuizText

      h3

        color $s1

      @media $small

        .Quiz_illustration

          margin-top 0px

    .QuizBase

      .Quiz_answers

        margin-top 60px!important
        margin-bottom 0px!important

        @media $xsmall

          margin-top 30px!important

        @media $xxsmall

          margin-top 15px!important

      .Quiz_content

        flex-grow 0!important
        margin-bottom 0px!important

      @media $medium

        min-height calc(100vh - 60px - 55px)
        min-height calc((100vh - 60px - 55px) - var(--vh, 0px));
        position relative
        box-sizing border-box

      .Quiz_illustration

        display none

      .Quiz_section_wrapper

        justify-content center

        @media $medium

          margin auto auto
          min-height auto
          top 50%
          position absolute
          left 50%
          transform translate(-50%, -50%)

    .Quiz_section

      display flex
      flex-direction column
      align-items center

      &_wrapper

        padding-top $s-l

        @media $medium

          padding-top $s-m
          
    // .Quiz

    //   &_content

    //     margin auto auto auto auto

    
    .Quiz_withIllustration

      .Quiz

        &_illustration

          margin auto

        &_answers

          margin 0px auto 0px auto

        &_content

          flex-grow 1
          display flex
          flex-direction column
          align-items center
          margin-top 0px
          margin-bottom auto
          justify-content space-between
          padding 0px
          box-shadow none
          border-radius 0px
          background transparent

        @media $medium

          &_section_wrapper

            padding-top 0px

          &_content

            display flex
            flex-direction column
            align-items center
            justify-content space-between
            padding 0px
            box-shadow none
            border-radius 0px
            background transparent

          &_illustration

            margin auto

          &_answers

            margin 0px auto auto auto

    .Quiz_withSlider

      .Quiz

        @media $medium

          &_illustration

            margin auto
        
          &_content

            flex-grow 1
            display flex
            flex-direction column
            align-items center
            justify-content space-between
            padding-bottom 45px
            margin-top 0px
            margin-bottom auto
</style>